/** @jsxImportSource @emotion/react */
import React from 'react'

type PencilIconProps = {
  width?: number
  height?: number
  className?: string
}

const PencilIcon: React.FC<PencilIconProps> = ({
  width = 24,
  height = 24,
  className,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      className={className}
    >
      <path
        d='M2.99878 17.4612V20.5012C2.99878 20.7812 3.21878 21.0012 3.49878 21.0012H6.53878C6.66878 21.0012 6.79878 20.9513 6.88878 20.8512L17.8088 9.94125L14.0588 6.19125L3.14878 17.1012C3.04878 17.2012 2.99878 17.3212 2.99878 17.4612ZM20.7088 7.04125C21.0988 6.65125 21.0988 6.02125 20.7088 5.63125L18.3688 3.29125C17.9788 2.90125 17.3488 2.90125 16.9588 3.29125L15.1288 5.12125L18.8788 8.87125L20.7088 7.04125Z'
        fill='#F2B400'
      />
    </svg>
  )
}

export default PencilIcon
